import { createFormDataRequest } from "@/helpers/FormHelpers";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import Note, { NoteForm } from "@/interfaces/Note";
import api from "@/services/api";

export const companyCourseNotesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanyCourseNotes: build.query<
      IPaginateResponse<Note>,
      [string, string, IFilters]
    >({
      query: ([companyId, courseId, data]) => {
        const params = createFormDataRequest(data);
        return {
          url: `/companies/${companyId}/courses/${courseId}/notes`,
          params,
        };
      },
      providesTags: (result, _error, [companyId, courseId]) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "CompanyCourseNote" as const,
                companyId,
                courseId,
                id,
              })),
              { type: "CompanyCourseNote", companyId, courseId, id: "LIST" },
            ]
          : [],
    }),
    storeCompanyCourseNote: build.mutation<Note, [string, string, NoteForm]>({
      query: ([companyId, courseId, body]) => ({
        url: `/companies/${companyId}/courses/${courseId}/notes`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, [companyId, courseId]) => [
        { type: "CompanyCourseNote", companyId, courseId },
        { type: "CompanyCourses", id: "LIST" },
      ],
    }),
    deleteCompanyCourseNote: build.mutation<void, [string, string, string]>({
      query: ([companyId, courseId, noteId]) => ({
        url: `/companies/${companyId}/courses/${courseId}/notes/${noteId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, [companyId, courseId]) => [
        { type: "CompanyCourseNote", companyId, courseId, id: "LIST" },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetCompanyCourseNotesQuery,
  useStoreCompanyCourseNoteMutation,
  useDeleteCompanyCourseNoteMutation,
} = companyCourseNotesApi;
